var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600.803,
    height: 426.361,
    viewBox: "0 0 600.803 426.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.211,
    y1: 3.614,
    x2: -0.211,
    y2: 0.343,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.036,
    y1: 4.542,
    x2: -0.036,
    y2: 1.284,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.017,
    y1: 4.446,
    x2: -0.017,
    y2: 1.187,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1.04,
    y1: 1.715,
    x2: -1.04,
    y2: 0.715,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.551,
    y1: 0.784,
    x2: 0.551,
    y2: 0.225,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_upload_87y9",
    transform: "translate(60.846 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4584",
    "data-name": "Path 4584",
    d: "M313.465,73.149c-17.926-7.287-36.869-13.388-56.207-12.611-28.453,1.119-55.706,18.22-69.093,43.331-11.343,21.272-12.741,46.21-17.627,69.817-6.019,29.09-17.545,56.733-29.861,83.768-6.617,14.5-13.595,29.355-14.68,45.274-1.509,22.1,9.057,44.122,25.622,58.836s38.581,22.454,60.654,24.147c11.753.9,24.031.068,34.472-5.4,11.044-5.787,19.093-16.247,30.18-21.948,10.277-5.3,22.295-6.028,33.83-5.339a151.5,151.5,0,0,1,44.17,9.385c16.122,6.057,31.115,14.825,47.2,20.964s34.062,9.568,50.507,4.442c15.432-4.823,27.653-16.493,38.663-28.333a495.838,495.838,0,0,0,49.287-62.356c9.93-14.873,19.17-30.566,23.563-47.9,8.391-33.141-3.159-70.535-28.786-93.172-21.219-18.75-49.716-26.891-77.605-31.829-25.43-4.5-54.833-4.784-78.242-16.522C357.187,96.486,336.874,82.669,313.465,73.149Z",
    transform: "translate(-112.837 -45.983)",
    fill: "#2648E8",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4585",
    "data-name": "Path 4585",
    d: "M813.67,141.184c-6.887.275-7.234,18.056-6.8,18.832s-1.563,8.8-1.563,8.8-3.125,12.167-2.763,14.429a4.214,4.214,0,0,1-1.683,3.742c-3.057,1.206-6.891,5.093-7.909,6.158l-.256.275a22.248,22.248,0,0,0-3.482,2.691c-.521.762-1.929.154-1.929.154a37.6,37.6,0,0,0-4.524-.231c-.357.106-.916-.55-1.234-.965-.149-.2-.246-.347-.246-.347l-.121-3.588a2.933,2.933,0,0,0-.482-.3c.082-.405.183-.825.309-1.254a10.743,10.743,0,0,0,4.384-3.935c.116-.183.222-.371.323-.559a1.447,1.447,0,0,0,.911.256,1.808,1.808,0,0,0,.424-.039,3.429,3.429,0,0,0,1.235-.622,6.606,6.606,0,0,0,2.3-2.691,4.367,4.367,0,0,0,.217-.641c-.072.121-.15.241-.227.357a3.709,3.709,0,0,0-.256-3.13,10.283,10.283,0,0,1-1.206-1.775c-.405-1.162.362-2.363.834-3.5a5.89,5.89,0,0,0,.429-3.3,4.215,4.215,0,0,0-1.784-2.783c-1.9-1.23-4.466-.555-6.66-1.148a18.037,18.037,0,0,1-2.291-.921,17.358,17.358,0,0,0-3.506-1.09c-1.191-.236-2.633-.26-3.376.67a6.914,6.914,0,0,0-.55.931,3.448,3.448,0,0,1-2.156,1.548,8.081,8.081,0,0,1-1.326.14,1.281,1.281,0,0,0,0-.55c-.559-1.833,1.042-3.193,3.125-4.012s10.007-7.06,10.928-8.541,7.369-6.125,7.369-6.125,9.645-2.73,12.809-12.674-15.133,6.945-16.975,7.451a18.772,18.772,0,0,0-4.48,2.411L769.741,152.1a42.494,42.494,0,0,0-6.327,4.369,21.246,21.246,0,0,0-4.639,6.626s-1.124,1.833-2.763,4.485a12.212,12.212,0,0,1-3.578,3.805l.053-.1c-.13.159-4.167,5.257-4.524,7.485s-2,11.309-2,11.309-1.447,7.133-2.44,8.536c0,0-.805,4.094-1.283,4.644s-2.411,6.351-2.083,6.94c0,0-1.842,4.017-1.519,5.536l-3.323,7.957s-1.8,3.935-1.683,6.236c.058,1.114.106,2.411.14,3.472v.482h0v.482c-.178.3-.637,1.061-1.114,1.982a10.323,10.323,0,0,0-1.37,4.046c.077,1.813.082,6.24-.752,7.866l-.246-.1a3.376,3.376,0,0,0-.482,1.6l.058.029c0,.14-.043.285-.058.439-.2,1.847.092,4.418-.371,4.982-.641.781-.323,18.094-.323,18.094s-1.042,10.836,1.042,17.7l-.159,5.377a50.093,50.093,0,0,0,.159,5.787,56.437,56.437,0,0,1,.323,5.85l1.2,8.579s-1.606,13.257-.241,16.532a18.017,18.017,0,0,1,1.447,5.7,8.857,8.857,0,0,0,2.209.854v.482l-.313,8.063v.444s-.039.212-.068.564h0v.2a.233.233,0,0,0,0,.058c0,.053,0,.111,0,.169a1.159,1.159,0,0,0,0,.13.977.977,0,0,1,0,.116v.728h0v.7a1.4,1.4,0,0,0,.039.241.248.248,0,0,0,0,.058,1.232,1.232,0,0,0,.053.265h0a1.027,1.027,0,0,0,.063.26.064.064,0,0,1,0,.029h0a.476.476,0,0,0,.039.135.239.239,0,0,0,0,.063.785.785,0,0,0,.048.164v.039c.048.135.1.27.154.405a.185.185,0,0,0,0,.043.414.414,0,0,0,.068.149l.029.068.063.13.039.072.068.121.043.072c0,.039.043.077.068.116s.034.048.048.077l.072.111.053.072.077.111.058.072.087.106.058.068.1.116.053.058.164.159a.256.256,0,0,0,.053.048,1.318,1.318,0,0,0,.121.111l.077.063.106.087.092.068.106.077.1.068.106.068.111.063.111.068.116.058.12.058.121.058.12.053.13.053.13.048.135.048.145.043.227.068.188.048.149.029.154.034h.164l.159.024h2.035l.26-.024h.159l.439-.048s5.464.815,5.642-1.345a1.727,1.727,0,0,1,.024-.347v-.275a.719.719,0,0,1,0-.1v-2.744c-.034-1.071-.087-2.064-.121-2.619a3.51,3.51,0,0,0-.029-.482s-1.862-2.807-1.558-3.858a27.768,27.768,0,0,0,.236-4.62s-.723-1.712-1.21-3.226c-.039-.116-.072-.232-.106-.342a17.793,17.793,0,0,0,1.138-1.447,18.325,18.325,0,0,0-1.36-11,.685.685,0,0,1-.294-.564.242.242,0,0,1,0-.058l.931-11.386-.564-6.626s-.4-4.528.482-6.477l1.76-17.154,2.5-9.978s.8-.391,1.447,1.485,2.238,10.369,2.238,10.369l3.858,14.039s.641,4.991,1.2,5.7.564,3.819.564,3.819,1.2,2.5,1.042,3.588a15.518,15.518,0,0,0,.4,5.069c.4,1.013.564,8.2.564,8.2a16.559,16.559,0,0,0,.159,7.1,25,25,0,0,1,.4,8.112,5.551,5.551,0,0,0,.328.453c-.039.106-.082.212-.121.309-.251.651-.448,1.109-.448,1.109a28.445,28.445,0,0,0,.241,4.62c.3,1.051-1.563,3.858-1.563,3.858s0,.174-.029.482c-.034.555-.087,1.543-.12,2.619v2.749a.638.638,0,0,0,0,.092v.28a1.778,1.778,0,0,0,.024.347c.183,2.161,5.647,1.346,5.647,1.346l.439.053h2.44l.164-.029.159-.024.154-.034.154-.029.188-.048.227-.068.14-.043.135-.048a1.041,1.041,0,0,0,.13-.048l.13-.053.125-.053.121-.053.121-.063.111-.058.116-.063.106-.067.111-.068.1-.068.106-.077a.65.65,0,0,0,.092-.067.884.884,0,0,0,.106-.082l.082-.068.121-.106.053-.053.164-.159.048-.058.106-.111.053-.072a.962.962,0,0,0,.092-.106l.053-.072.082-.111.048-.072.077-.111a.686.686,0,0,1,.048-.077c0-.039.044-.077.068-.116l.043-.072c0-.043.043-.082.063-.121a.551.551,0,0,0,.039-.072c0-.043.043-.087.063-.13l.034-.068c0-.048.043-.1.068-.15v-.043c.053-.135.106-.27.15-.405V353.6a.514.514,0,0,1,.053-.159.346.346,0,0,1,0-.068.184.184,0,0,1,.039-.135v-.024a.063.063,0,0,0,0-.029,1.177,1.177,0,0,1,.068-.256h0a1.661,1.661,0,0,1,.053-.26v-.063a1.865,1.865,0,0,1,.039-.236.19.19,0,0,0,0-.082v-.627h0v-.844a1.219,1.219,0,0,1,0-.13v-.169a.241.241,0,0,1,0-.058v-.193h0c-.029-.352-.063-.564-.063-.564v-.439l-.3-7.8v-.482c.448-.251.907-.535,1.384-.868,0,0-.082-4.446,1.2-6.236s-.641-6.477-.641-6.477l-.8-16.768.318-7.716a7.671,7.671,0,0,1-.964-3.742,13.615,13.615,0,0,0-1.283-4.823s-.8-2.652.164-3.434-1.042-17.844-1.042-17.844.482-12.466-.434-19.869v-.121l.256-.116c-.077-.593-.159-1.148-.251-1.664l-.27.082a13.542,13.542,0,0,0-.482-1.929l-1.283-5.888s-.029-.309-.063-.757c-.043-.53-.092-1.249-.1-1.881a3.189,3.189,0,0,1,.087-.791l-.068-.058a1.754,1.754,0,0,1,.068-.41l-.28-.236s-.039-.265-.068-.67a7.544,7.544,0,0,1,.347-3.342c.641-1.288,7.234-6.163,7.234-6.163l3.694-7.393s3.685-5.189,6.486-6.2,11.531-6.819,11.531-6.819,3.043-3.12,3.284-3.858l.1-.154h.058v-.1l8.2-12.283c3.279-2.652,3.4-8.3,3.4-8.3l.854-12.915-.28-7.639.4-4.34S820.552,140.914,813.67,141.184ZM766.708,174.6a10.332,10.332,0,0,0-1.36,5.122v.468a10.3,10.3,0,0,0,1.094,4.619,3.786,3.786,0,0,0-.8,1.414,7.668,7.668,0,0,1-1.659-3.111,3.238,3.238,0,0,0-1.283-2.1s-.222-2.363.077-2.768l.043-.039s.034-.058.1-.154h0c.342-.516,1.495-2.257,2.686-4.239a3.8,3.8,0,0,0,.613.2l.733.183Z",
    transform: "translate(-425.033 -83.182)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4586",
    "data-name": "Path 4586",
    d: "M855.474,216.751c.072-.164.13-.338.188-.511a10.662,10.662,0,0,0-.482,1.182C855.281,217.195,855.383,216.973,855.474,216.751Z",
    transform: "translate(-490.439 -126.63)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4587",
    "data-name": "Path 4587",
    d: "M806.407,239.511s-1.509,7.2-4.292,8.126,3.376,9.163,3.376,9.163l12.765-.7.231-2.667s-2.411-5.339,1.625-11.835S806.407,239.511,806.407,239.511Z",
    transform: "translate(-462.591 -137.922)",
    fill: "#f6bac2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4588",
    "data-name": "Path 4588",
    d: "M756.48,571.535c-.174,2.146-5.454,1.336-5.454,1.336-8.758,1.215-7.311-7.369-7.311-7.369v-.439l.3-8.006.087-2.233s9.645-4.408,9.4-3.482a5.488,5.488,0,0,0,.391,2.083c.482,1.5,1.172,3.2,1.172,3.2a28.835,28.835,0,0,1-.232,4.581c-.289,1.042,1.509,3.829,1.509,3.829s0,.174.029.482A56.25,56.25,0,0,1,756.48,571.535Z",
    transform: "translate(-432.683 -300.061)",
    fill: "#b77983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4589",
    "data-name": "Path 4589",
    d: "M799.388,574.894s-5.281.815-5.454-1.336a54.839,54.839,0,0,1,.092-6.033,4.31,4.31,0,0,1,.024-.482s1.8-2.787,1.509-3.829a28.893,28.893,0,0,1-.231-4.586s.188-.449.434-1.095c.516-1.355,1.292-3.554,1.133-4.181-.232-.931,9.4,3.477,9.4,3.477l.1,2.5.294,7.74v.439S808.151,576.114,799.388,574.894Z",
    transform: "translate(-458.707 -301.1)",
    fill: "#b77983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4590",
    "data-name": "Path 4590",
    d: "M825.34,139.011a19.771,19.771,0,0,1-12.375,12.572s-6.231,4.62-7.118,6.067-8.546,7.658-10.561,8.473-3.554,2.165-3.014,3.979c.482,1.683-4.794,9.92-5.589,11.145h0l-.1.154-1.664,1.741L779.274,186l-4.6-1.471L774.09,179l2.44-4.34h0a11.975,11.975,0,0,0,3.458-3.776c1.587-2.633,2.672-4.446,2.672-4.446a21.218,21.218,0,0,1,4.485-6.578,40.578,40.578,0,0,1,6.11-4.34l11.338-6.752a18.28,18.28,0,0,1,4.34-2.411C810.722,145.844,828.4,129.148,825.34,139.011Z",
    transform: "translate(-448.456 -85.035)",
    fill: "#f6bac2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4591",
    "data-name": "Path 4591",
    d: "M779.274,224.069l7.542-1.509a.482.482,0,0,0-.135.313h0l-.1.154-1.664,1.741-5.647,2.86-4.6-1.471-.583-5.527,2.44-4.34h0c-2.31,4.823-.058,8.247-.058,8.247Z",
    transform: "translate(-448.456 -126.656)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4592",
    "data-name": "Path 4592",
    d: "M865.1,272.162a1.393,1.393,0,0,0-.053.154,2.118,2.118,0,0,1-.28.482l-3.043,1.485-4.644.482-2.411-5.84,1.606-6.4.887-1.2.246-.27c.092,1.157.559,7.2.53,9.009-.039,2.011,1.447,2.17,1.447,2.17Z",
    transform: "translate(-490.175 -149.835)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4593",
    "data-name": "Path 4593",
    d: "M806.287,249.291a1.4,1.4,0,0,0-.053.154c-.232.733-3.168,3.829-3.168,3.829s-8.435,5.763-11.14,6.752-6.269,6.149-6.269,6.149L782.1,273.52s-6.38,4.823-7,6.115a7.62,7.62,0,0,0-.333,3.318,3.44,3.44,0,0,0,.058.666l-1.881,1.963-1.5,1.563-2.112,2.2-3.439-.482-10.716-1.7L753.122,286l-11.405-6.424s0-.4-.029-1.013c0-.27,0-.579-.029-.921-.034-1.042-.082-2.339-.135-3.443-.116-2.281,1.625-6.187,1.625-6.187l3.207-7.895c-.309-1.5,1.471-5.493,1.471-5.493-.309-.579,1.548-6.342,2.011-6.882s1.24-4.606,1.24-4.606c.964-1.389,2.358-8.469,2.358-8.469s1.587-8.975,1.929-11.217,4.244-7.268,4.369-7.422c-2.783,5.1-.347,8.816-.347,8.816l2.787-.482,7.547-1.471c-.347.231-.116,2.783-.116,2.783a3.217,3.217,0,0,1,1.235,2.088c.072,1.133,1.447,2.894,1.7,3.207l.039.043a3.776,3.776,0,0,1,1.818-2.595l1.741,2.324.584,2.783s-.159.391-1.162,1.162.424,2.783.424,2.783a14.175,14.175,0,0,1,.622,3.829h0a5.639,5.639,0,0,1,3.284-1.119,9.942,9.942,0,0,0,1.972-2.826,1.167,1.167,0,0,1,1.664-.772,10.689,10.689,0,0,1,1.9-1.317c.931-.482,2.011.482,2.011.482l.116,3.564s.092.145.241.342c.3.424.849,1.075,1.191.965a35.319,35.319,0,0,1,4.369.231s1.355.579,1.857-.154a22.876,22.876,0,0,1,3.376-2.667s.555,7.181.555,9.187,1.447,2.17,1.447,2.17Z",
    transform: "translate(-431.592 -126.522)",
    fill: "#d39999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4594",
    "data-name": "Path 4594",
    d: "M875.891,284.77h-.1C875.973,284.288,875.891,284.77,875.891,284.77Z",
    transform: "translate(-501.11 -162)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    cx: 0.694,
    cy: 0.694,
    r: 0.694,
    transform: "translate(342.35 117.373)",
    fill: "#4b4442"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    cx: 0.694,
    cy: 0.694,
    r: 0.694,
    transform: "translate(337.281 127.472)",
    fill: "#4b4442"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 0.694,
    cy: 0.694,
    r: 0.694,
    transform: "translate(327.303 149.091)",
    fill: "#4b4442"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 0.694,
    cy: 0.694,
    r: 0.694,
    transform: "translate(332.02 138.183)",
    fill: "#4b4442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4595",
    "data-name": "Path 4595",
    d: "M754.4,553.426c-3.627,4.311-7.542,4.239-9.877,3.631l.087-2.233s9.645-4.408,9.4-3.482A5.123,5.123,0,0,0,754.4,553.426Z",
    transform: "translate(-433.146 -300.061)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4596",
    "data-name": "Path 4596",
    d: "M808.42,559.367c-6.159,3.559-9.771-.612-10.61-1.794.516-1.355,1.293-3.554,1.133-4.181-.232-.931,9.4,3.477,9.4,3.477Z",
    transform: "translate(-460.736 -301.121)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4597",
    "data-name": "Path 4597",
    d: "M776.817,444.285c-1.235,1.78-1.162,6.187-1.162,6.187-7.967,5.724-12.143-1.239-12.143-1.239a25.615,25.615,0,0,0-.386-8.044,16.787,16.787,0,0,1-.154-7.041s-.154-7.118-.545-8.121a15.534,15.534,0,0,1-.386-5.03c.154-1.085-1-3.554-1-3.554s0-3.1-.545-3.791S759.335,408,759.335,408l-3.709-13.923s-1.548-8.43-2.165-10.287-1.394-1.471-1.394-1.471l-2.228,9.978-1.7,17.019c-.854,1.929-.482,6.424-.482,6.424l.54,6.573-.9,11.294a.233.233,0,0,0,0,.058.689.689,0,0,0,.28.559,18.585,18.585,0,0,1,1.3,10.909c-5.879,8.512-13,4.1-13,4.1a18.049,18.049,0,0,0-1.389-5.642c-1.317-3.25.231-16.4.231-16.4l-1.162-8.512a56.965,56.965,0,0,0-.309-5.787,50.951,50.951,0,0,1-.154-5.724l.154-5.339c-2.011-6.81-1.008-17.559-1.008-17.559s-.309-17.173.313-17.95c.448-.559.164-3.106.357-4.943a3.447,3.447,0,0,1,.453-1.587l.077-.077c1.008-1.239,1.008-6.187.926-8.126a10.435,10.435,0,0,1,1.326-4.012c.482-.936.921-1.707,1.085-1.987l.068-.111s4.408,1.085,16.088,6.655a21.954,21.954,0,0,0,6.646,2.059,14.787,14.787,0,0,0,3.467.053,12.1,12.1,0,0,0,4.987-1.62,8.765,8.765,0,0,0,2.156-1.731,14.424,14.424,0,0,0,0,3.115c.029.449.063.752.063.752l1.288,5.739a15.071,15.071,0,0,1,.482,2.078c.092.511.169,1.066.241,1.654.9,7.34.419,19.71.419,19.71s1.929,16.942,1.008,17.713-.159,3.4-.159,3.4a13.732,13.732,0,0,1,1.24,4.794,7.716,7.716,0,0,0,.931,3.713l-.313,7.658.81,16.614S778.056,442.506,776.817,444.285Z",
    transform: "translate(-426.659 -193.543)",
    fill: "#8499f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4598",
    "data-name": "Path 4598",
    d: "M806.13,489.875s5.859-3.376,7.137-1.857S806.13,489.875,806.13,489.875Z",
    transform: "translate(-465.044 -267.138)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4599",
    "data-name": "Path 4599",
    d: "M813.236,496.14s-.965.482,1.162,1.1S813.236,496.14,813.236,496.14Z",
    transform: "translate(-468.61 -271.546)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4600",
    "data-name": "Path 4600",
    d: "M739.994,476.81c-.2.058,4.876,3.424,9.457.637C749.432,477.447,741.137,476.463,739.994,476.81Z",
    transform: "translate(-430.8 -261.5)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4601",
    "data-name": "Path 4601",
    d: "M753.82,490.24a6.219,6.219,0,0,1-4.234,3.135C746.741,493.78,753.82,490.24,753.82,490.24Z",
    transform: "translate(-435.42 -268.491)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4602",
    "data-name": "Path 4602",
    d: "M797.71,502.52s6.675,10.61,5.4,13.113S797.71,502.52,797.71,502.52Z",
    transform: "translate(-460.685 -274.849)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4603",
    "data-name": "Path 4603",
    d: "M773.625,369.09l-.694,20.771s4.118-.174,4.823-7.017,1.22-12.418,1.22-12.418Z",
    transform: "translate(-447.855 -205.767)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4604",
    "data-name": "Path 4604",
    d: "M773.145,368.13,772.45,388.9s4.118-.174,4.823-7.022,1.23-12.413,1.23-12.413Z",
    transform: "translate(-447.607 -205.27)",
    fill: "#8499f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4605",
    "data-name": "Path 4605",
    d: "M745.1,369.372s-3.25,8.714-10.687,4.495a3.431,3.431,0,0,1,.453-1.587c2.035.854,6.752,2.1,8.681-3.55Z",
    transform: "translate(-427.912 -205.581)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4606",
    "data-name": "Path 4606",
    d: "M744.617,367.447s-3.25,8.714-10.687,4.495a3.45,3.45,0,0,1,.453-1.587c2.035.858,6.752,2.1,8.681-3.545Z",
    transform: "translate(-427.663 -204.587)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4607",
    "data-name": "Path 4607",
    d: "M744.617,368.407s-3.25,8.714-10.687,4.495a3.449,3.449,0,0,1,.453-1.587c2.035.858,6.752,2.1,8.681-3.545Z",
    transform: "translate(-427.663 -205.084)",
    fill: "#8499f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4608",
    "data-name": "Path 4608",
    d: "M803.1,379.666c-8.169,3.887-11.164-5.276-11.164-5.276l1.929.058c.338,5.859,6.8,4.282,9.009,3.564C802.955,378.542,803.032,379.078,803.1,379.666Z",
    transform: "translate(-457.697 -208.511)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4609",
    "data-name": "Path 4609",
    d: "M804.064,378.221C795.9,382.1,792.9,372.94,792.9,372.94l1.929.058c.338,5.859,6.8,4.287,9.009,3.569C803.915,377.078,803.992,377.632,804.064,378.221Z",
    transform: "translate(-458.194 -207.76)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4610",
    "data-name": "Path 4610",
    d: "M803.584,378.7c-8.165,3.882-11.164-5.281-11.164-5.281l1.929.058c.338,5.864,6.8,4.287,9.009,3.569C803.435,377.558,803.512,378.112,803.584,378.7Z",
    transform: "translate(-457.946 -208.009)",
    fill: "#8499f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4611",
    "data-name": "Path 4611",
    d: "M744.617,368.407s-3.25,8.714-10.687,4.495a3.449,3.449,0,0,1,.453-1.587c2.035.858,6.752,2.1,8.681-3.545Z",
    transform: "translate(-427.663 -205.084)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4612",
    "data-name": "Path 4612",
    d: "M803.584,378.7c-8.165,3.882-11.164-5.281-11.164-5.281l1.929.058c.338,5.864,6.8,4.287,9.009,3.569C803.435,377.558,803.512,378.112,803.584,378.7Z",
    transform: "translate(-457.946 -208.009)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4613",
    "data-name": "Path 4613",
    d: "M756.54,584.618a13.691,13.691,0,0,1-.058,1.606c-.174,2.146-5.454,1.336-5.454,1.336-4.823.67-6.559-1.645-7.133-3.858a8.829,8.829,0,0,1-.265-2.2,9.122,9.122,0,0,1,.087-1.321v-.439a3.227,3.227,0,0,1,3,.612c2.146,1.741,4.991.405,4.991.405a6.7,6.7,0,0,1,2.894.868c.453.391,1.2-.55,1.77-1.447.034.579.087,1.625.121,2.744C756.53,583.5,756.54,584.078,756.54,584.618Z",
    transform: "translate(-432.685 -314.759)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4614",
    "data-name": "Path 4614",
    d: "M748.072,586.551s-1.447,1.418-4.176-.772a8.83,8.83,0,0,1-.265-2.2C745.024,584.641,747.609,586.551,748.072,586.551Z",
    transform: "translate(-432.685 -316.817)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4615",
    "data-name": "Path 4615",
    d: "M768.717,588.178a1.09,1.09,0,0,1-1.567-.251,10.3,10.3,0,0,0,1.543-1.447C768.708,587.059,768.717,587.637,768.717,588.178Z",
    transform: "translate(-444.863 -318.319)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4616",
    "data-name": "Path 4616",
    d: "M793.869,586.682a14.787,14.787,0,0,0,.053,1.606c.174,2.151,5.454,1.336,5.454,1.336,4.823.675,6.559-1.64,7.133-3.858a9.261,9.261,0,0,0,.178-3.52v-.439a3.266,3.266,0,0,0-3,.612c-2.146,1.741-4.987.405-4.987.405a6.724,6.724,0,0,0-2.894.873c-.453.391-1.2-.55-1.765-1.447-.034.579-.092,1.625-.125,2.744C793.874,585.558,793.864,586.137,793.869,586.682Z",
    transform: "translate(-458.695 -315.83)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4617",
    "data-name": "Path 4617",
    d: "M811.43,588.6s1.447,1.418,4.172-.772a8.8,8.8,0,0,0,.27-2.194C814.473,586.686,811.888,588.6,811.43,588.6Z",
    transform: "translate(-467.788 -317.879)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4618",
    "data-name": "Path 4618",
    d: "M793.869,590.238a1.085,1.085,0,0,0,1.563-.251,10.2,10.2,0,0,1-1.543-1.447C793.874,589.114,793.864,589.693,793.869,590.238Z",
    transform: "translate(-458.695 -319.385)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4619",
    "data-name": "Path 4619",
    d: "M775.064,285s-7.427,20.5-4.567,22.28S775.064,285,775.064,285Z",
    transform: "translate(-446.256 -162.23)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4620",
    "data-name": "Path 4620",
    d: "M790.939,271.88s-1.4,6.81-.7,7.427S790.939,271.88,790.939,271.88Z",
    transform: "translate(-456.716 -155.437)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4621",
    "data-name": "Path 4621",
    d: "M813.83,304.77s-9.129,8.507-8.512,9.206S813.83,304.77,813.83,304.77Z",
    transform: "translate(-464.608 -172.466)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4622",
    "data-name": "Path 4622",
    d: "M824.982,261.1c-3.458,1.056-11.54,3.525-11.632,3.506l.449-1.842a5.639,5.639,0,0,1,3.284-1.119,9.944,9.944,0,0,0,1.973-2.826,1.167,1.167,0,0,1,1.664-.772,10.981,10.981,0,0,1,1.9-1.317c.931-.482,2.011.482,2.011.482l.116,3.559S824.833,260.907,824.982,261.1Z",
    transform: "translate(-468.782 -147.526)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4623",
    "data-name": "Path 4623",
    d: "M824.982,260.164c-3.458,1.056-11.54,3.525-11.632,3.5l.449-1.837a5.639,5.639,0,0,1,3.284-1.119,9.945,9.945,0,0,0,1.973-2.826,1.167,1.167,0,0,1,1.664-.772,10.7,10.7,0,0,1,1.9-1.317c.931-.482,2.011.482,2.011.482l.116,3.564S824.833,259.957,824.982,260.164Z",
    transform: "translate(-468.782 -147.04)",
    fill: "#d39999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4624",
    "data-name": "Path 4624",
    d: "M808.808,251.272a14.124,14.124,0,0,1,.617,3.829l-1.345,1.071-2.556-7.369-.116-3.829-.048-.217.039.043a3.757,3.757,0,0,1,1.818-2.59l1.741,2.32.584,2.783s-.159.391-1.162,1.162S808.808,251.272,808.808,251.272Z",
    transform: "translate(-464.645 -140.076)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4625",
    "data-name": "Path 4625",
    d: "M809.3,250.772a14.173,14.173,0,0,1,.622,3.829l-1.346,1.085-2.556-7.369-.116-3.829-.053-.217.039.043a3.776,3.776,0,0,1,1.818-2.595l1.741,2.325.583,2.783s-.159.391-1.162,1.162S809.3,250.772,809.3,250.772Z",
    transform: "translate(-464.899 -139.822)",
    fill: "#d39999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4626",
    "data-name": "Path 4626",
    d: "M825.942,223.135a10.354,10.354,0,1,1-3.031-7.412A10.441,10.441,0,0,1,825.942,223.135Z",
    transform: "translate(-464.49 -124.792)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4627",
    "data-name": "Path 4627",
    d: "M825.932,222.171a10.383,10.383,0,1,1-3.042-7.4A10.446,10.446,0,0,1,825.932,222.171Z",
    transform: "translate(-464.48 -124.295)",
    fill: "#f6bac2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4628",
    "data-name": "Path 4628",
    d: "M827.35,222.157a10.384,10.384,0,0,1-1.519,5.425c-.154-.275-.246-.593-.4-.873-.217-.391-.719-.719-1.09-.482a1.113,1.113,0,0,0-.343.482c-.3.641-.844,1.283-1.553,1.268a1.538,1.538,0,0,1-1.321-1.128,4.634,4.634,0,0,1-.077-1.842c.106-1.254.125-2.7-.805-3.545a5.276,5.276,0,0,0-2.016-.9,2.644,2.644,0,0,1-1.736-1.283c-.193-.482-.145-.993-.318-1.447a2.532,2.532,0,0,0-1.876-1.379,4.918,4.918,0,0,1-3.284,1.124,12.306,12.306,0,0,1-3.231-.511,10.446,10.446,0,0,1,19.57,5.078Z",
    transform: "translate(-465.898 -124.281)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4629",
    "data-name": "Path 4629",
    d: "M814.356,211.814c.174.482.125,1,.318,1.447a2.632,2.632,0,0,0,1.736,1.283,5.305,5.305,0,0,1,2.016.9c.931.849.912,2.3.805,3.549a4.633,4.633,0,0,0,.077,1.842,1.548,1.548,0,0,0,1.321,1.128,1.919,1.919,0,0,0,1.553-1.268,1.123,1.123,0,0,1,.342-.482c.371-.246.873.082,1.09.482a4.776,4.776,0,0,0,.622,1.172,1.389,1.389,0,0,0,1.268.289,3.2,3.2,0,0,0,1.191-.617,6.531,6.531,0,0,0,2.218-2.667,3.83,3.83,0,0,0-.14-3.376,10.132,10.132,0,0,1-1.162-1.765c-.4-1.153.347-2.339.806-3.467a6.019,6.019,0,0,0,.41-3.275,4.2,4.2,0,0,0-1.721-2.763c-1.833-1.22-4.312-.55-6.433-1.138a16.321,16.321,0,0,1-2.213-.911,16.4,16.4,0,0,0-3.376-1.08c-1.153-.231-2.546-.26-3.274.661a7.3,7.3,0,0,0-.531.926,3.332,3.332,0,0,1-2.083,1.534c-.622.149-1.273.111-1.929.2a2.122,2.122,0,0,0-1.606.921,3.2,3.2,0,0,0-.106,1.929,1.958,1.958,0,0,1-.482,1.818c-.246.188-.584.28-.733.545a.767.767,0,0,0,.227.911,2.175,2.175,0,0,0,.921.405,14.1,14.1,0,0,0,3.7.632,4.88,4.88,0,0,0,3.443-1.268c-.082.082-.613.048-.709.043A2.817,2.817,0,0,1,814.356,211.814Z",
    transform: "translate(-464.083 -118.718)",
    fill: "#7e646b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(340.331 86.263)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4630",
    "data-name": "Path 4630",
    d: "M827.441,229.194a3.284,3.284,0,0,1-1.191.622,1.4,1.4,0,0,1-1.263-.294,4.706,4.706,0,0,1-.627-1.172c-.217-.391-.719-.719-1.09-.482a1.182,1.182,0,0,0-.342.482,1.889,1.889,0,0,1-1.553,1.268,1.529,1.529,0,0,1-1.317-1.128,4.639,4.639,0,0,1-.082-1.842c.111-1.254.125-2.7-.8-3.545a5.3,5.3,0,0,0-2.021-.9,2.655,2.655,0,0,1-1.736-1.283c-.193-.482-.145-.993-.318-1.447a2.521,2.521,0,0,0-1.876-1.379,5.006,5.006,0,0,1-3.284,1.128,14.3,14.3,0,0,1-3.7-.637,2.232,2.232,0,0,1-.921-.4,1.023,1.023,0,0,1-.15-.174,1.351,1.351,0,0,0-.54.42.767.767,0,0,0,.227.911,2.175,2.175,0,0,0,.921.405,14.1,14.1,0,0,0,3.7.632,4.963,4.963,0,0,0,3.279-1.124,2.523,2.523,0,0,1,1.881,1.374c.174.482.125,1,.318,1.447a2.644,2.644,0,0,0,1.736,1.283,5.3,5.3,0,0,1,2.016.9c.931.849.911,2.3.805,3.549a4.635,4.635,0,0,0,.077,1.842,1.548,1.548,0,0,0,1.321,1.129,1.919,1.919,0,0,0,1.553-1.268,1.125,1.125,0,0,1,.342-.482c.371-.246.873.082,1.09.482a4.635,4.635,0,0,0,.627,1.172,1.379,1.379,0,0,0,1.264.289,3.2,3.2,0,0,0,1.191-.617,6.529,6.529,0,0,0,2.218-2.667,4.27,4.27,0,0,0,.207-.637A6.876,6.876,0,0,1,827.441,229.194Z",
    transform: "translate(-804.565 -213.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4631",
    "data-name": "Path 4631",
    d: "M854,220.322c.1-.222.2-.444.289-.661a4.386,4.386,0,0,0,.178-.511,11.426,11.426,0,0,0-.468,1.172Z",
    transform: "translate(-830.16 -214.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4632",
    "data-name": "Path 4632",
    d: "M807.112,212.189a1.977,1.977,0,0,0,.439-1.775,7.882,7.882,0,0,1-.092-1.114,1.636,1.636,0,0,0-.265.338,3.194,3.194,0,0,0-.106,1.929A3.743,3.743,0,0,1,807.112,212.189Z",
    transform: "translate(-805.822 -209.3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4633",
    "data-name": "Path 4633",
    d: "M774.11,354.137c-.9.063-2.156.13-3.67.183-1.051.034-2.228.058-3.487.058-1.1,0-2.262,0-3.467-.053a74.339,74.339,0,0,1-11.367-1.172c-5.011-.964-9.645-2.628-12.539-5.445.482-.936.921-1.712,1.085-1.987,0-.27,0-.583-.029-.921,5.088,2.411,20.949,9.11,33.107,5.3a3.44,3.44,0,0,0,.058.665l.275.232A14.635,14.635,0,0,0,774.11,354.137Z",
    transform: "translate(-430.588 -193.191)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4634",
    "data-name": "Path 4634",
    d: "M774.11,353.171c-.9.063-2.156.13-3.67.178-1.051.039-2.228.058-3.487.058-1.1,0-2.262,0-3.467-.053a74.337,74.337,0,0,1-11.367-1.167c-5.011-.965-9.645-2.633-12.539-5.45.482-.936.921-1.707,1.085-1.987,0-.27,0-.579-.029-.921,5.088,2.411,20.949,9.115,33.107,5.329a3.441,3.441,0,0,0,.058.666l.275.231A14.453,14.453,0,0,0,774.11,353.171Z",
    transform: "translate(-430.588 -192.689)",
    fill: "#4b4442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4635",
    "data-name": "Path 4635",
    d: "M310.427,570.708a6.63,6.63,0,0,1-1.481-5.049l21.287-174.178L332,377.014a6.679,6.679,0,0,1,6.578-5.864l62.351-.415a6.67,6.67,0,0,0,6.626-6.853l-.024-.661a6.674,6.674,0,0,1,6.67-6.9h65.52a6.67,6.67,0,0,1,6.67,6.655,7.109,7.109,0,0,1-.058.9,6.67,6.67,0,0,0,6.443,7.552L555.7,373.03a6.665,6.665,0,0,1,6.4,7.793L530.646,564.564l-.593,3.472a6.526,6.526,0,0,1-.964,2.488Z",
    transform: "translate(-207.606 -199.156)",
    fill: "#b7b6cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(220.128 118.853)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 126.752,
    height: 38.754,
    transform: "matrix(0.568, -0.823, 0.823, 0.568, 0, 104.284)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    width: 36.845,
    height: 125.055,
    transform: "matrix(0.823, 0.568, -0.568, 0.823, 292.714, 120.264)",
    fill: "#f9fafb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    width: 26.012,
    height: 26.012,
    transform: "matrix(0.821, 0.571, -0.571, 0.821, 294.898, 125.138)",
    fill: "#f7b643"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_780",
    "data-name": "Rectangle 780",
    width: 26.047,
    height: 26.047,
    transform: "matrix(0.823, 0.568, -0.568, 0.823, 278.166, 150.878)",
    fill: "#f7b643",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_781",
    "data-name": "Rectangle 781",
    width: 26.047,
    height: 26.047,
    transform: "matrix(0.823, 0.568, -0.568, 0.823, 260.287, 176.75)",
    fill: "#f7b643",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(213.479 112.646)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    width: 126.279,
    height: 38.754,
    transform: "matrix(0.28, -0.96, 0.96, 0.28, 0, 121.209)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 36.845,
    height: 124.582,
    transform: "matrix(0.96, 0.28, -0.28, 0.96, 249.884, 113.819)",
    fill: "#f9fafb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    width: 26.047,
    height: 26.047,
    transform: "matrix(0.96, 0.28, -0.28, 0.96, 254.527, 117.271)",
    fill: "#f97878"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 26.047,
    height: 26.047,
    transform: "matrix(0.96, 0.28, -0.28, 0.96, 245.705, 147.454)",
    fill: "#f97878",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 26.047,
    height: 26.047,
    transform: "matrix(0.96, 0.28, -0.28, 0.96, 236.885, 177.632)",
    fill: "#f97878",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(213.546 114.751)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 126.279,
    height: 38.754,
    transform: "matrix(0.08, -0.997, 0.997, 0.08, 0, 125.873)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    width: 36.845,
    height: 124.582,
    transform: "matrix(0.997, 0.08, -0.08, 0.997, 224.834, 115.705)",
    fill: "#f9fafb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    width: 26.047,
    height: 26.047,
    transform: "matrix(0.997, 0.08, -0.08, 0.997, 230.061, 118.148)",
    fill: "#73b53b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    "data-name": "Rectangle 790",
    width: 26.047,
    height: 26.047,
    transform: "matrix(0.997, 0.08, -0.08, 0.997, 227.536, 149.486)",
    fill: "#73b53b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_791",
    "data-name": "Rectangle 791",
    width: 26.047,
    height: 26.047,
    transform: "matrix(0.997, 0.08, -0.08, 0.997, 225.016, 180.833)",
    fill: "#73b53b",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(207.001 118.142)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    "data-name": "Rectangle 792",
    width: 38.754,
    height: 126.279,
    transform: "translate(0 1.765) rotate(-2.61)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    "data-name": "Rectangle 793",
    width: 36.845,
    height: 124.582,
    transform: "translate(208.311 120.697) rotate(-2.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_794",
    "data-name": "Rectangle 794",
    width: 26.047,
    height: 26.047,
    transform: "translate(213.798 122.457) rotate(-2.61)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_795",
    "data-name": "Rectangle 795",
    width: 26.079,
    height: 26.079,
    transform: "translate(216.25 152.874) rotate(-2.862)",
    fill: "#6c63ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_796",
    "data-name": "Rectangle 796",
    width: 26.047,
    height: 26.047,
    transform: "translate(216.661 185.283) rotate(-2.61)",
    fill: "#6c63ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4637",
    "data-name": "Path 4637",
    d: "M393.168,470.4l-32.736,12.664a246.048,246.048,0,0,1-55.624,5.112c-11.333-18.779-30.083-47.99-46.779-73.66L234.77,357.773,330.494,330Z",
    transform: "translate(-169.227 -185.529)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4638",
    "data-name": "Path 4638",
    d: "M412.629,447.521S361.775,477.6,285.848,470.8L225.32,323.228l29.008-4.987L354.609,301.02l56.907,143.631Z",
    transform: "translate(-164.335 -170.524)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4639",
    "data-name": "Path 4639",
    d: "M442.638,444.691a240.4,240.4,0,0,1-39.767-1.133c-15.085-1.775-30.257-5.43-43.263-12.134a131.112,131.112,0,0,1-28.28-19c-21.089-18.967-34.139-46.1-45.858-94.147L385.751,301.06Z",
    transform: "translate(-195.477 -170.545)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4640",
    "data-name": "Path 4640",
    d: "M472.64,390.3s-37.486,7.34-75.642,2.821c-15.085-1.775-30.257-5.43-43.263-12.134a131.23,131.23,0,0,1-28.28-19c-26.1-23.481-39.883-59.467-54.095-132.139,0,0,62.318,15.042,123.941-17.906C395.281,211.974,416.052,341.6,472.64,390.3Z",
    transform: "translate(-188.172 -124.409)",
    fill: "#f9fafb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4641",
    "data-name": "Path 4641",
    d: "M455.073,539.232c-15.085-1.775-30.257-5.43-43.263-12.134a131.221,131.221,0,0,1-28.28-19c22.223-1.8,25.415-13.952,25.415-13.952C425.419,520.293,455.073,539.232,455.073,539.232Z",
    transform: "translate(-246.247 -270.516)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4642",
    "data-name": "Path 4642",
    d: "M338.2,289.6s50.676-2.865,64.825-13.788l2.146,6.9s-33.483,14.772-66.971,14.95Z",
    transform: "translate(-222.777 -157.472)",
    fill: "#6c63ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4643",
    "data-name": "Path 4643",
    d: "M338.2,352.893s49.065-2.686,86.136-20.592l1.254,2.865s-29.418,17.173-87.39,21.668Z",
    transform: "translate(-222.777 -186.719)",
    fill: "#6c63ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4644",
    "data-name": "Path 4644",
    d: "M346.39,380.4s49.065-2.686,86.131-20.593l1.254,2.865s-29.418,17.168-87.385,21.668Z",
    transform: "translate(-227.018 -200.962)",
    fill: "#6c63ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4645",
    "data-name": "Path 4645",
    d: "M354.57,407.953s49.065-2.686,86.136-20.593l1.249,2.865S412.538,407.4,354.57,411.893Z",
    transform: "translate(-231.253 -215.226)",
    fill: "#6c63ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4646",
    "data-name": "Path 4646",
    d: "M362.76,435.5s49.065-2.686,86.131-20.592l1.254,2.865s-29.418,17.173-87.385,21.668Z",
    transform: "translate(-235.493 -229.49)",
    fill: "#6c63ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4647",
    "data-name": "Path 4647",
    d: "M370.94,463.062s49.065-2.686,86.136-20.592l1.249,2.865S428.908,462.5,370.94,467Z",
    transform: "translate(-239.728 -243.759)",
    fill: "#6c63ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4648",
    "data-name": "Path 4648",
    d: "M1066.787,827.212s-20.39-1.23-17.988,13.06a3.474,3.474,0,0,0,1.813,3.67s.034-1.061,2.088-.7a9.361,9.361,0,0,0,2.218.106,4.58,4.58,0,0,0,2.705-1.119h0s5.734-2.368,7.962-11.733c0,0,1.649-2.045,1.582-2.57l-3.438,1.447a6.162,6.162,0,0,1,.251,4.543s-.111-4.451-.772-4.34c-.135,0-1.789.858-1.789.858s2.02,4.34.482,7.465c0,0,.579-5.329-1.128-7.152l-2.411,1.413s2.363,4.466.762,8.112c0,0,.41-5.589-1.273-7.769l-2.194,1.712s2.223,4.4.868,7.427c0,0-.178-6.51-1.346-7a12.486,12.486,0,0,0-2.209,2.411s1.519,3.193.574,4.88c0,0-.579-4.34-1.052-4.34,0,0-1.929,2.893-2.112,4.823a10.431,10.431,0,0,1,1.649-5.117,5.786,5.786,0,0,0-2.932,1.519s.3-2.035,3.4-2.209a13.557,13.557,0,0,1,2-2.315,12.6,12.6,0,0,0-4.958.574s1.649-1.929,5.527-1.046l2.165-1.765s-4.066-.56-5.787.058c0,0,1.982-1.7,6.37-.482l2.358-1.408a21.473,21.473,0,0,0-5.527-.482s2.175-1.177,6.221.1l1.683-.757s-2.537-.482-3.279-.579-.786-.28-.786-.28a8.747,8.747,0,0,1,4.77.53S1066.845,827.438,1066.787,827.212Z",
    transform: "translate(-590.582 -442.942)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 14.429,
    cy: 2.44,
    rx: 14.429,
    ry: 2.44,
    transform: "translate(447.733 399.803)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 49.19,
    cy: 4.456,
    rx: 49.19,
    ry: 4.456,
    transform: "translate(311.745 388.678)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4649",
    "data-name": "Path 4649",
    d: "M1095.007,729.414s-11.492-.694-10.127,7.364a1.962,1.962,0,0,0,1.017,2.069s.024-.6,1.181-.4a5.35,5.35,0,0,0,1.249.058,2.574,2.574,0,0,0,1.524-.627h0s3.231-1.336,4.49-6.617c0,0,.931-1.152.892-1.447l-1.929.825a3.5,3.5,0,0,1,.14,2.566s-.063-2.513-.434-2.455c-.077,0-1.008.482-1.008.482s1.138,2.411.28,4.21c0,0,.328-3-.637-4.036l-1.365.8s1.331,2.517.429,4.572c0,0,.231-3.154-.719-4.379l-1.235.964s1.249,2.484.482,4.186c0,0-.1-3.67-.757-3.945a7.714,7.714,0,0,0-1.249,1.345s.858,1.8.328,2.754c0,0-.328-2.445-.593-2.455a8.06,8.06,0,0,0-1.191,2.725,5.906,5.906,0,0,1,.931-2.894,3.231,3.231,0,0,0-1.654.858s.169-1.148,1.929-1.244a7.7,7.7,0,0,1,1.128-1.307,7.106,7.106,0,0,0-2.8.323s.931-1.08,3.115-.588l1.225-1a10.08,10.08,0,0,0-3.265.034s1.119-.965,3.593-.26l1.331-.8a12.011,12.011,0,0,0-3.12-.265,4.764,4.764,0,0,1,3.506.053l.964-.425s-1.447-.284-1.852-.328-.444-.159-.444-.159a4.979,4.979,0,0,1,2.691.3A11.659,11.659,0,0,0,1095.007,729.414Z",
    transform: "translate(-609.306 -392.314)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 8.136,
    cy: 1.374,
    rx: 8.136,
    ry: 1.374,
    transform: "translate(469.656 345.858)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4650",
    "data-name": "Path 4650",
    d: "M952.035,743.911s-13.88-.839-12.24,8.888a2.368,2.368,0,0,0,1.23,2.5s0-.723,1.447-.482a6.328,6.328,0,0,0,1.51.072,3.115,3.115,0,0,0,1.842-.762h0s3.9-1.611,5.421-7.986c0,0,1.124-1.389,1.075-1.751l-2.368,1a4.185,4.185,0,0,1,.169,3.091s-.077-3.029-.526-2.961c-.092,0-1.215.588-1.215.588s1.374,2.942.338,5.083c0,0,.4-3.627-.767-4.871l-1.649.964s1.606,3.043.516,5.522c0,0,.28-3.8-.863-5.3l-1.495,1.167s1.514,2.995.588,5.054c0,0-.116-4.432-.912-4.765a9.072,9.072,0,0,0-1.5,1.625s1.032,2.175.391,3.323c0,0-.4-2.951-.719-2.966a10.089,10.089,0,0,0-1.447,3.294,7.122,7.122,0,0,1,1.124-3.482,3.905,3.905,0,0,0-1.992,1.037s.2-1.384,2.315-1.5a8.9,8.9,0,0,1,1.365-1.572,8.546,8.546,0,0,0-3.376.386s1.119-1.3,3.757-.709l1.476-1.206a12.267,12.267,0,0,0-3.94.039s1.35-1.153,4.34-.309l1.606-.965a14.6,14.6,0,0,0-3.766-.323s1.485-.8,4.234.068l1.148-.516s-1.727-.338-2.233-.391-.53-.193-.53-.193a5.961,5.961,0,0,1,3.245.357A14.87,14.87,0,0,0,952.035,743.911Z",
    transform: "translate(-534.179 -399.818)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    cx: 9.824,
    cy: 1.659,
    rx: 9.824,
    ry: 1.659,
    transform: "translate(398.475 354.669)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_217",
    "data-name": "Ellipse 217",
    cx: 19.982,
    cy: 2.44,
    rx: 19.982,
    ry: 2.44,
    transform: "translate(65.625 397.354)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4651",
    "data-name": "Path 4651",
    d: "M68.1,821.157s11.394-.251,14.833-2.016,17.531-3.858,18.386-1.047,17.13,14.092,4.261,14.169-29.9-1.447-33.333-2.956S68.1,821.157,68.1,821.157Z",
    transform: "translate(4.09 -432.701)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4652",
    "data-name": "Path 4652",
    d: "M105.8,836.028c-12.87.077-29.9-1.447-33.333-2.956-2.6-1.148-3.647-5.271-4.007-7.171H68.08s.721,6.641,4.147,8.15,20.51,3.038,33.346,2.99c3.713-.024,5-.965,4.929-2.411C109.981,835.478,108.565,836.013,105.8,836.028Z",
    transform: "translate(4.097 -437.454)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_797",
    "data-name": "Rectangle 797",
    width: 82.307,
    height: 147.292,
    transform: "matrix(0.309, -0.951, 0.951, 0.309, 349.341, 78.276)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_798",
    "data-name": "Rectangle 798",
    width: 81.174,
    height: 145.256,
    transform: "matrix(0.309, -0.951, 0.951, 0.309, 350.483, 78.054)",
    fill: "#f6f7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(375.322 28.459)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_218",
    "data-name": "Ellipse 218",
    cx: 15.124,
    cy: 15.124,
    r: 15.124,
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(426.628 36.922)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_799",
    "data-name": "Rectangle 799",
    width: 4.143,
    height: 65.891,
    transform: "matrix(0.309, -0.951, 0.951, 0.309, 0, 3.94)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(423.362 46.966)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_800",
    "data-name": "Rectangle 800",
    width: 4.143,
    height: 33.565,
    transform: "matrix(0.309, -0.951, 0.951, 0.309, 0, 3.94)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(420.091 57.017)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_801",
    "data-name": "Rectangle 801",
    width: 4.143,
    height: 54.288,
    transform: "matrix(0.309, -0.951, 0.951, 0.309, 0, 3.94)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(416.826 67.063)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_802",
    "data-name": "Rectangle 802",
    width: 4.143,
    height: 65.891,
    transform: "matrix(0.309, -0.951, 0.951, 0.309, 0, 3.94)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(456.237 96.305)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    "data-name": "Rectangle 803",
    width: 8.01,
    height: 18.234,
    transform: "matrix(0.309, -0.951, 0.951, 0.309, 0, 7.618)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4653",
    "data-name": "Path 4653",
    d: "M861.137,468.854a4.419,4.419,0,0,0-.048-.482,2.453,2.453,0,0,0-.082-.482c-.063-.328-.13-.651-.207-.965-.039-.15-.077-.3-.121-.449a12.23,12.23,0,0,0-2.411-4.663c-.063-.077-.13-.149-.193-.222s-.26-.28-.391-.41-.251-.246-.376-.357-.241-.212-.357-.309c-.232-.188-.448-.347-.637-.482a3.93,3.93,0,0,0-.391-.251,2.142,2.142,0,0,0-.907-.294l-2-.2h0l-2.734-.27-9.775-3.8-.386.135a22.134,22.134,0,0,1-.723-2.411,2.161,2.161,0,0,0,.772-.564,1.761,1.761,0,0,0,.53-.68c.246-.569-.227-1.78-.13-2.474a11.67,11.67,0,0,1,1.206-3.2,14.832,14.832,0,0,0,1.616-6.892,7.773,7.773,0,0,0-3.212-6.115c-1.037-.69-2.257-1.056-3.337-1.683-.839-.482-1.577-1.128-2.378-1.678A13.667,13.667,0,0,0,821,428.7a65.683,65.683,0,0,0-5.676,3.694,9.582,9.582,0,0,1-6.414,1.765,1.556,1.556,0,0,0-.068.28l-.188-.024c-.386,1.051.559,2.093,1.447,2.812,1.654,1.365,3.53,2.725,5.686,2.773a5.974,5.974,0,0,1,2.474.183,2.271,2.271,0,0,1,.482.289,10.745,10.745,0,0,0,3.376,10.711l-4.991-1.794s-.207.106-.53.309l-6.925-4.61s-13.884-5.035-17.742,2.807,16.72,3.8,16.72,3.8l4.4,2.411a4.008,4.008,0,0,0,.482,2.643l12,7.417a63.4,63.4,0,0,1-7.118,1.929c-1.027,0-3.858,1.013-5.657,5.059s-8.232,23.785-13.889,27.074-20.573,25.3-20.573,25.3l.068.174c-.265.072-.526.145-.781.231a15.808,15.808,0,0,0-7.75,5.845,2.479,2.479,0,0,0,1.736,3.911c5.888.747,9.105-1.968,10.653-4.017.1-.13.193-.26.28-.391a2.059,2.059,0,0,0,1.447.068l7.2-5.821s-5.633,5.546-2.329,10.61l-.251.352a80.494,80.494,0,0,0-12.056,26.245s-3.086,2.276-3.342,11.386-3.347,23.785-3.347,23.785-2.054,17.463-.772,22.772c0,0,.15.212.424.535-.1.116-.2.241-.318.367-1.124,1.215-3.149,2.894-5.507,2.411-3.6-.762-3.6,5.565,1.543,6.072a137.034,137.034,0,0,1,14.043,2.817,2.956,2.956,0,0,0,3.665-3.154,26.713,26.713,0,0,0-1.543-6.964c-.053-.121-.106-.241-.159-.352.149-.145.3-.289.453-.444,0,0,0-11.135,1.8-14.169,0,0,4.885-23.028,4.625-28.849-.2-4.552,12.679-22.285,18.282-29.775l-.048-.285c1.447-1.929,2.344-3.086,2.344-3.086L813,571.387s2.059,6.072,4.63,9.361c0,0,11.058,21,12.346,27.58a20.745,20.745,0,0,0,3.9,9.076l-.333.318a5.63,5.63,0,0,1-4.851,1.741c-3.6-.762-3.6,5.565,1.543,6.072a138.134,138.134,0,0,1,14.039,2.821,2.961,2.961,0,0,0,3.67-3.159c-.294-2.633-.868-5.908-1.977-7.842a5.459,5.459,0,0,0-.294-.482,2.71,2.71,0,0,0,1.022-.719S840,600.212,840,595.9c0,0-2.826-16.445-12.341-22.517,0,0,.9-20.573,3.607-32.022.068-.28.135-.559.2-.83a76.311,76.311,0,0,0,7.5-1.562l.256-7.591,1.288,6.072,14.4-8.854s-.125-1.6-.367-4.041c-.125-1.225-.275-2.662-.453-4.22-.145-1.244-.309-2.566-.482-3.916-.048-.338-.092-.68-.14-1.018-.188-1.365-.4-2.744-.617-4.094q-.13-.762-.26-1.5c-.121-.661-.241-1.307-.367-1.929-.063-.313-.13-.627-.193-.931s-.135-.608-.2-.9-.135-.579-.2-.863c-.039-.14-.072-.28-.106-.415-.072-.275-.145-.545-.217-.805a14.476,14.476,0,0,1-.521-3.318V499.3a9.558,9.558,0,0,1,.13-1.331c.029-.217.067-.439.111-.656a14.7,14.7,0,0,1,.728-2.585c.159-.42.342-.834.54-1.244.482-.965.965-1.992,1.476-3.086.26-.545.521-1.1.781-1.673s.526-1.148.791-1.736c2.5-5.58,4.972-11.8,5.633-15.881.067-.429.121-.834.145-1.215a7.755,7.755,0,0,0,.014-1.042Z",
    transform: "translate(-441.741 -235.941)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4654",
    "data-name": "Path 4654",
    d: "M851.353,474.143l-8.483-5.734s-13.469-4.991-17.212,2.744,16.214,3.742,16.214,3.742l8.483,4.736Z",
    transform: "translate(-474.913 -256.368)",
    fill: "#ae6e79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_804",
    "data-name": "Rectangle 804",
    width: 81.137,
    height: 126.31,
    transform: "matrix(0.541, -0.841, 0.841, 0.541, 284.407, 265.351)",
    fill: "#f9fafb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    width: 22.956,
    height: 5.401,
    transform: "matrix(0.536, -0.844, 0.844, 0.536, 300.152, 260.59)",
    fill: "#b7b6cc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    width: 50.415,
    height: 4.953,
    transform: "matrix(0.536, -0.844, 0.844, 0.536, 314.724, 264.515)",
    fill: "#b7b6cc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_807",
    "data-name": "Rectangle 807",
    width: 50.415,
    height: 4.953,
    transform: "matrix(0.536, -0.844, 0.844, 0.536, 323.655, 270.183)",
    fill: "#b7b6cc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    "data-name": "Rectangle 808",
    width: 50.415,
    height: 4.953,
    transform: "matrix(0.536, -0.844, 0.844, 0.536, 332.582, 275.861)",
    fill: "#b7b6cc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_809",
    "data-name": "Rectangle 809",
    width: 50.345,
    height: 4.946,
    transform: "matrix(0.541, -0.841, 0.841, 0.541, 341.82, 284.088)",
    fill: "#b7b6cc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_810",
    "data-name": "Rectangle 810",
    width: 50.415,
    height: 4.953,
    transform: "matrix(0.536, -0.844, 0.844, 0.536, 350.44, 287.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_811",
    "data-name": "Rectangle 811",
    width: 50.415,
    height: 4.953,
    transform: "matrix(0.536, -0.844, 0.844, 0.536, 359.37, 292.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_812",
    "data-name": "Rectangle 812",
    width: 13.055,
    height: 13.055,
    transform: "matrix(0.536, -0.844, 0.844, 0.536, 396.861, 268.702)",
    fill: "#b7b6cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4655",
    "data-name": "Path 4655",
    d: "M912.6,830.648a132.4,132.4,0,0,0-13.619-2.778c-4.991-.482-4.991-6.752-1.495-5.99a5.4,5.4,0,0,0,4.7-1.712,11.021,11.021,0,0,0,.965-1.056,2.894,2.894,0,0,1,1.615-.989c1.871-.405,5.787-1.022,8.155.265a3.524,3.524,0,0,1,1.292,1.418c1.075,1.929,1.635,5.136,1.929,7.716a2.894,2.894,0,0,1-3.545,3.125Z",
    transform: "translate(-511.07 -437.987)",
    fill: "#bebed0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4656",
    "data-name": "Path 4656",
    d: "M781.737,835.84a132.127,132.127,0,0,0-13.614-2.778c-4.992-.482-4.992-6.752-1.5-5.985,2.286.482,4.254-1.162,5.339-2.358.135-.145.255-.285.357-.415a2.9,2.9,0,0,1,1.611-.965c1.871-.41,5.787-1.027,8.16.265a4.414,4.414,0,0,1,1.712,2.281,27,27,0,0,1,1.5,6.863,2.893,2.893,0,0,1-3.559,3.091Z",
    transform: "translate(-443.318 -440.686)",
    fill: "#bebed0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4657",
    "data-name": "Path 4657",
    d: "M792.17,825.867c-5.956,6.139-11.063-.116-11.84-1.148.135-.145.256-.285.357-.415a2.9,2.9,0,0,1,1.611-.965c1.871-.41,5.787-1.027,8.16.265A4.165,4.165,0,0,1,792.17,825.867Z",
    transform: "translate(-451.686 -440.686)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4658",
    "data-name": "Path 4658",
    d: "M921.932,819.807c-2.58,1.76-11.266,1.326-11.266,1.326a8.155,8.155,0,0,1-.786-.965,11,11,0,0,0,.964-1.056,2.894,2.894,0,0,1,1.615-.988c1.871-.405,5.787-1.023,8.155.265A3.525,3.525,0,0,1,921.932,819.807Z",
    transform: "translate(-518.76 -437.987)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4659",
    "data-name": "Path 4659",
    d: "M854.772,729.8c-1.751,2.247-11.724,1.746-11.724,1.746s-2.995-2.995-4.244-9.476-11.975-27.19-11.975-27.19c-2.493-3.245-4.49-9.23-4.49-9.23l-4.239-27.19s-20.453,26.939-20.2,32.678-4.495,28.453-4.495,28.453c-1.746,2.995-1.746,13.986-1.746,13.986-6.482,6.752-11.97-1.249-11.97-1.249-1.249-5.237.748-22.449.748-22.449s2.995-14.468,3.241-23.448,3.246-11.222,3.246-11.222a79.991,79.991,0,0,1,11.714-25.878c1.5-2.156,2.5-3.308,2.5-3.308l40.409,4.741a25.437,25.437,0,0,0-1.736,5.353c-2.628,11.285-3.5,31.564-3.5,31.564,9.23,5.985,11.974,22.184,11.974,22.184C848.285,714.081,854.772,729.8,854.772,729.8Z",
    transform: "translate(-451.142 -349.145)",
    fill: "#5c5c8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(333.871 296.865)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4660",
    "data-name": "Path 4660",
    d: "M822.035,675.133l-.521-3.323s-20.453,26.939-20.2,32.678-4.49,28.453-4.49,28.453c-1.751,2.995-1.751,13.986-1.751,13.986a8.528,8.528,0,0,1-3.9,2.5c1.963.516,4.34.135,6.9-2.5,0,0,0-10.976,1.746-13.986,0,0,4.741-22.7,4.49-28.453C804.109,700,816.595,682.511,822.035,675.133Z",
    transform: "translate(-791.17 -659.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4661",
    "data-name": "Path 4661",
    d: "M871.981,709.832s-2.744-16.214-11.97-22.184c0,0,.873-20.279,3.5-31.564a25.408,25.408,0,0,1,1.741-5.353L824.84,646s-.1.106-.27.318l37.684,4.422a25.44,25.44,0,0,0-1.736,5.353c-2.628,11.285-3.5,31.564-3.5,31.564,9.23,5.985,11.974,22.184,11.974,22.184,0,4.239,6.486,19.956,6.486,19.956-1.032,1.321-4.919,1.693-7.943,1.775,2.411.063,9.486.087,10.933-1.775C878.468,729.788,871.981,714.071,871.981,709.832Z",
    transform: "translate(-808.463 -646)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4662",
    "data-name": "Path 4662",
    d: "M794.431,634.128a9.114,9.114,0,0,1-1.182,2.064c-1.5,2.021-4.62,4.692-10.33,3.959a2.455,2.455,0,0,1-1.688-3.858,15.369,15.369,0,0,1,7.518-5.787,13.73,13.73,0,0,1,3.188-.646Z",
    transform: "translate(-451.918 -340.778)",
    fill: "#ae6e79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4663",
    "data-name": "Path 4663",
    d: "M892.546,486.2l-20-7.316s-5.739,2.995-3.492,7.234l19.479,12.225Z",
    transform: "translate(-497.35 -262.61)",
    fill: "#42383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4664",
    "data-name": "Path 4664",
    d: "M892.7,486.366l-20.009-7.316s-5.739,2.99-3.492,7.234L888.654,498.5Z",
    transform: "translate(-497.428 -262.698)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4665",
    "data-name": "Path 4665",
    d: "M908.257,468.522s-.251,11.724,4.991,15.717-15.22,6.236-15.22,6.236,3.246-11.974,0-18.21S908.257,468.522,908.257,468.522Z",
    transform: "translate(-512.362 -256.992)",
    fill: "#ae6e79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4666",
    "data-name": "Path 4666",
    d: "M862.332,650.691a25.448,25.448,0,0,0-1.736,5.353c-24.113,3.685-40.92-6.351-40.92-6.351-.092-.145-.179-.289-.256-.434,1.5-2.156,2.5-3.308,2.5-3.308Z",
    transform: "translate(-471.925 -349.109)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4667",
    "data-name": "Path 4667",
    d: "M802.991,634.154a9.113,9.113,0,0,1-1.182,2.064c-2.31-.386-4.157-4.823-4.5-5.662a13.722,13.722,0,0,1,3.188-.646Z",
    transform: "translate(-460.478 -340.804)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4668",
    "data-name": "Path 4668",
    d: "M859.115,490.78l-8.98,3.241-3.742,4.991s-7.716,2.493-8.729,2.493-3.742,1-5.488,4.987-7.981,23.457-13.469,26.693-19.956,24.943-19.956,24.943,2.493,6.752,5.488,5.739l6.983-5.739s-5.488,5.488-2.247,10.479c0,0,20.457,12.22,48.645,4.736l.246-7.48,1.249,5.985,13.985-8.729s-1.249-16.1-3.5-24.3a14.814,14.814,0,0,1,.964-10.325c3.622-7.547,9.211-20.154,8.531-24.749-.805-5.416-3.858-7.769-5.035-8.478a2.083,2.083,0,0,0-.878-.294l-4.567-.453Z",
    transform: "translate(-461.223 -268.771)",
    fill: "#42383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4669",
    "data-name": "Path 4669",
    d: "M858.633,542.76s-4.991,23.2-10.479,26.939-20.2,15.717-20.7,17.713",
    transform: "translate(-476.082 -295.683)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4670",
    "data-name": "Path 4670",
    d: "M853.978,541.21s-4.987,23.2-10.475,26.939-20.207,15.717-20.7,17.709",
    transform: "translate(-473.675 -294.881)",
    fill: "#42383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4671",
    "data-name": "Path 4671",
    d: "M897.28,502.767s17.212-5.739,22.184-4.244",
    transform: "translate(-512.236 -272.651)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(397.047 222.009)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4672",
    "data-name": "Path 4672",
    d: "M935.034,532.8c3.622-7.547,9.211-20.154,8.531-24.749-.806-5.416-3.858-7.769-5.035-8.478a2.082,2.082,0,0,0-.877-.294l-1.929-.193a1.928,1.928,0,0,1,.579.236c1.167.714,4.229,3.062,5.03,8.483.68,4.591-4.909,17.2-8.526,24.75a14.806,14.806,0,0,0-.964,10.32c2.257,8.2,3.506,24.3,3.506,24.3l-12.027,7.519.3,1.447,13.985-8.729s-1.249-16.1-3.5-24.3A14.816,14.816,0,0,1,935.034,532.8Z",
    transform: "translate(-922.766 -495.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4673",
    "data-name": "Path 4673",
    d: "M896.708,463.842l2.16.217-9.394-3.709-.844.3Z",
    transform: "translate(-888.63 -460.35)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4674",
    "data-name": "Path 4674",
    d: "M887.45,587.632s7.716-4.239,10.229-3.241,11.724-.251,11.724-.251",
    transform: "translate(-507.147 -317.107)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4675",
    "data-name": "Path 4675",
    d: "M907.416,472.714c-.285-2.5.873-2.122.873-2.122s-13.47-2.493-10.229,3.742a14.282,14.282,0,0,1,1.37,5.483h.13C903.3,479.822,905.487,475.636,907.416,472.714Z",
    transform: "translate(-512.379 -258.064)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 10.725,
    cy: 10.725,
    r: 10.725,
    transform: "translate(376.44 199.309)",
    fill: "#ae6e79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4676",
    "data-name": "Path 4676",
    d: "M891.685,452.769a14.952,14.952,0,0,0,1.567-6.8,7.706,7.706,0,0,0-3.115-6.033c-1-.675-2.189-1.037-3.236-1.654-.815-.482-1.534-1.114-2.31-1.654a13.074,13.074,0,0,0-13.06-.965,60.008,60.008,0,0,0-5.5,3.646,9.22,9.22,0,0,1-6.221,1.741c-.376,1.037.545,2.059,1.389,2.773,1.606,1.345,3.424,2.686,5.517,2.73a5.774,5.774,0,0,1,2.411.183,3.458,3.458,0,0,1,1.225,1.138,22.471,22.471,0,0,1,2.546,4.316,3.578,3.578,0,0,0,1.138,1.678c.965.617,2.214.1,3.376.058,1.775-.072,3.376,1.047,4.688,2.243s2.566,2.566,4.225,3.2c1.239.482,3.718.453,4.34-1.027.236-.559-.222-1.755-.125-2.44A11.8,11.8,0,0,1,891.685,452.769Z",
    transform: "translate(-492.79 -239.561)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4677",
    "data-name": "Path 4677",
    d: "M892.149,452.239a14.886,14.886,0,0,0,1.567-6.79,7.715,7.715,0,0,0-3.111-6.033c-1.008-.68-2.194-1.042-3.236-1.659-.815-.482-1.534-1.109-2.31-1.654a13.074,13.074,0,0,0-13.06-.964,59.951,59.951,0,0,0-5.5,3.641,9.194,9.194,0,0,1-6.221,1.741c-.376,1.042.54,2.064,1.389,2.773,1.606,1.346,3.424,2.686,5.517,2.734a5.7,5.7,0,0,1,2.411.183,3.374,3.374,0,0,1,1.225,1.138,22.175,22.175,0,0,1,2.542,4.311,3.587,3.587,0,0,0,1.143,1.678c.964.617,2.214.1,3.376.058,1.775-.068,3.376,1.051,4.683,2.247a14.189,14.189,0,0,0,4.229,3.193c1.239.482,3.718.453,4.34-1.027.241-.559-.217-1.755-.121-2.44a11.8,11.8,0,0,1,1.138-3.13Z",
    transform: "translate(-493.033 -239.286)",
    fill: "#42383c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4678",
    "data-name": "Path 4678",
    d: "M529.078,606.36a4.972,4.972,0,0,1-3.193,1.128l-215.459-.916a6.631,6.631,0,0,1-1.481-5.049l21.287-174.177,13.349-.145a5.044,5.044,0,0,1,4.919,3.723l2.493,9.2a5.045,5.045,0,0,0,4.987,3.723l53.275-1.278a5.044,5.044,0,0,0,4.924-5.044v-6.1a5.045,5.045,0,0,1,4.987-5.044l73.824-.8a5.045,5.045,0,0,1,5,4.094L530.641,600.4l.212,1.1A5.016,5.016,0,0,1,529.078,606.36Z",
    transform: "translate(-207.606 -235.019)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4679",
    "data-name": "Path 4679",
    d: "M443.463,430.6l-73.824.8a5.044,5.044,0,0,0-4.991,5.04v6.1a5.044,5.044,0,0,1-4.919,5.04l-53.27,1.278a5.04,5.04,0,0,1-4.991-3.723l-2.5-9.2a5.04,5.04,0,0,0-4.924-3.723l-71.157.767a5.04,5.04,0,0,0-4.919,5.884L246.59,607.343a5.044,5.044,0,0,0,4.953,4.2l224.8.965a5.045,5.045,0,0,0,4.972-5.99L448.464,434.694A5.04,5.04,0,0,0,443.463,430.6Z",
    transform: "translate(-160.489 -237.613)",
    fill: "#e6e8ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4680",
    "data-name": "Path 4680",
    d: "M877.13,172.081l-.386,4.292.28,7.591-.815,12.8s-.116,5.609-3.284,8.237l-8.087,12.418-.048.024-3.043,1.485-4.644.482-2.411-5.84,1.6-6.414.887-1.2.246-.27c.965-1.061,4.688-4.914,7.644-6.115a4.184,4.184,0,0,0,1.625-3.713c-.347-2.267,2.662-14.313,2.662-14.313s1.929-7.967,1.509-8.743-.077-18.413,6.578-18.683S877.13,172.081,877.13,172.081Z",
    transform: "translate(-490.186 -94.47)",
    fill: "#f6bac2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_220",
    "data-name": "Ellipse 220",
    cx: 10.826,
    cy: 1.075,
    rx: 10.826,
    ry: 1.075,
    transform: "translate(29.462 372.618)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_221",
    "data-name": "Ellipse 221",
    cx: 10.826,
    cy: 1.075,
    rx: 10.826,
    ry: 1.075,
    transform: "translate(-12.006 375.652)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_222",
    "data-name": "Ellipse 222",
    cx: 10.826,
    cy: 1.075,
    rx: 10.826,
    ry: 1.075,
    transform: "translate(-60.846 371.543)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_223",
    "data-name": "Ellipse 223",
    cx: 7.694,
    cy: 0.762,
    rx: 7.694,
    ry: 0.762,
    transform: "translate(7.723 384.612)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_224",
    "data-name": "Ellipse 224",
    cx: 7.694,
    cy: 0.762,
    rx: 7.694,
    ry: 0.762,
    transform: "translate(-35.314 383.85)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4681",
    "data-name": "Path 4681",
    d: "M99.6,673.388s15.18-35.938-2.378-50.333c-13.137-10.769-28.05-9.481-34.728-8.15a12.182,12.182,0,0,0-7.961,4.779c-2.337,3.636-1.917,9.539,14.566,16.431,27.589,11.536,29.305,27.359,29.305,27.359Z",
    transform: "translate(-101.018 -296.897)",
    fill: "#46b585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4682",
    "data-name": "Path 4682",
    d: "M70.54,626.41s44.746,10.127,34.728,53.386",
    transform: "translate(-106.675 -303.305)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4683",
    "data-name": "Path 4683",
    d: "M107.4,633.92s-6.164,3-4.2,7.509",
    transform: "translate(-117.394 -307.193)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4684",
    "data-name": "Path 4684",
    d: "M77.26,637.635a9.828,9.828,0,0,1,8.355-1.239",
    transform: "translate(-108.907 -308.237)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4685",
    "data-name": "Path 4685",
    d: "M103.75,667.342s6.618-2.411,8.328.613",
    transform: "translate(-117.706 -324.026)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4686",
    "data-name": "Path 4686",
    d: "M125.746,678.771s-4.969-.285-5.056,1.447",
    transform: "translate(-123.332 -330.406)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4687",
    "data-name": "Path 4687",
    d: "M110.107,710.25s-17.785-26.119-22.667-25.56a4.528,4.528,0,0,0-3.874,3.578,7.872,7.872,0,0,0,.968,6.356C87.059,698.821,93.838,706.754,110.107,710.25Z",
    transform: "translate(-110.906 -333.475)",
    fill: "#46b585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4688",
    "data-name": "Path 4688",
    d: "M89.71,695s18.66,19.541,22.266,20.4",
    transform: "translate(-113.042 -338.817)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 4.354,
    transform: "translate(-25.049 359.236)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 6.832,
    y2: 0.212,
    transform: "translate(-19.833 366.383)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x1: 0.741,
    y2: 2.57,
    transform: "translate(-16.413 360.663)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x1: 0.134,
    y2: 2.334,
    transform: "translate(-8.546 368.481)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4689",
    "data-name": "Path 4689",
    d: "M122.66,710.25s17.778-26.119,22.66-25.56a4.513,4.513,0,0,1,3.874,3.578,7.872,7.872,0,0,1-.968,6.356C145.7,698.821,138.916,706.754,122.66,710.25Z",
    transform: "translate(-123.987 -333.475)",
    fill: "#46b585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4690",
    "data-name": "Path 4690",
    d: "M145.323,695s-18.7,19.541-22.273,20.4",
    transform: "translate(-124.116 -338.817)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x1: 4.354,
    transform: "translate(18.569 359.236)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x1: 6.832,
    y2: 0.212,
    transform: "translate(10.875 366.383)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 0.741,
    y2: 2.57,
    transform: "translate(13.547 360.663)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x2: 0.134,
    y2: 2.334,
    transform: "translate(6.287 368.481)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4691",
    "data-name": "Path 4691",
    d: "M76.415,746.541a2.319,2.319,0,0,1-1.008-1.1c-.17-.449.127-.922.708-1.124a2.433,2.433,0,0,1,1.87.482,2.847,2.847,0,0,0,1.81.613,1.7,1.7,0,0,1-.855-1.871.684.684,0,0,1,.234-.381,1.5,1.5,0,0,1,1.449.063,3.487,3.487,0,0,1,1.763,3.255,4.5,4.5,0,0,0,0-1.341,1.267,1.267,0,0,1,.748-1.172,2.751,2.751,0,0,1,1.062-.183,2.83,2.83,0,0,1,1.73.357.983.983,0,0,1-.067,1.529,6.912,6.912,0,0,1-1.79,1.032,3.748,3.748,0,0,0-1.276.883.573.573,0,0,0-.093.154H78.812A11.607,11.607,0,0,1,76.415,746.541Z",
    transform: "translate(-108.276 -363.665)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4692",
    "data-name": "Path 4692",
    d: "M177.864,724.752a2.288,2.288,0,0,1-1.008-1.1c-.171-.448.123-.92.7-1.124a2.432,2.432,0,0,1,1.87.482,2.917,2.917,0,0,0,1.823.632,1.7,1.7,0,0,1-.862-1.866.694.694,0,0,1,.24-.381,1.51,1.51,0,0,1,1.449.058,3.438,3.438,0,0,1,1.763,3.26,4.537,4.537,0,0,0,0-1.346,1.226,1.226,0,0,1,.668-1.186,2.823,2.823,0,0,1,1.062-.178,2.87,2.87,0,0,1,1.73.352.984.984,0,0,1-.073,1.534,6.757,6.757,0,0,1-1.783,1.032,3.719,3.719,0,0,0-1.276.878.693.693,0,0,0-.093.159h-3.8a11.475,11.475,0,0,1-2.411-1.206Z",
    transform: "translate(-141.971 -352.398)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4693",
    "data-name": "Path 4693",
    d: "M144.051,746.567a2.371,2.371,0,0,1-1.015-1.1c-.17-.449.127-.922.708-1.124a2.432,2.432,0,0,1,1.87.482,2.937,2.937,0,0,0,1.823.637,1.715,1.715,0,0,1-.862-1.871.7.7,0,0,1,.24-.381,1.5,1.5,0,0,1,1.449.063,3.438,3.438,0,0,1,1.763,3.255,4.506,4.506,0,0,0,0-1.341,1.243,1.243,0,0,1,.7-1.186,2.728,2.728,0,0,1,1.062-.183,2.84,2.84,0,0,1,1.73.357.981.981,0,0,1-.073,1.529,6.863,6.863,0,0,1-1.783,1.032,3.744,3.744,0,0,0-1.276.883.571.571,0,0,0-.093.154h-3.874A11.651,11.651,0,0,1,144.051,746.567Z",
    transform: "translate(-130.739 -363.69)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4694",
    "data-name": "Path 4694",
    d: "M47.069,706.25s-1.449,1.37.668,3.439,3.867,3.815,3.159,5.1c0,0-3.2-3.858-5.8-3.892S44.2,708.541,47.069,706.25Z",
    transform: "translate(-97.796 -344.642)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4695",
    "data-name": "Path 4695",
    d: "M47.071,706.25a1.6,1.6,0,0,0-.294.429c-2.538,2.156-3.894,4.167-1.449,4.22,2.271.048,5,2.98,5.65,3.723a1.406,1.406,0,0,1-.073.169s-3.2-3.858-5.8-3.892S44.206,708.541,47.071,706.25Z",
    transform: "translate(-97.799 -344.642)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4696",
    "data-name": "Path 4696",
    d: "M44.66,709.539c0,.482.073.873.167.873s.167-.391.167-.873-.094-.256-.187-.256S44.66,709.056,44.66,709.539Z",
    transform: "translate(-98.079 -346.184)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4697",
    "data-name": "Path 4697",
    d: "M43.092,710.715a2.928,2.928,0,0,0,1.142.309c.047-.058-.394-.289-.982-.521s-.354-.063-.4,0S42.5,710.484,43.092,710.715Z",
    transform: "translate(-97.439 -346.782)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4698",
    "data-name": "Path 4698",
    d: "M58.177,706.25s1.456,1.37-.668,3.439-3.867,3.815-3.159,5.1c0,0,3.2-3.858,5.8-3.892S61.042,708.541,58.177,706.25Z",
    transform: "translate(-101.245 -344.642)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4699",
    "data-name": "Path 4699",
    d: "M58.217,706.25a1.711,1.711,0,0,1,.3.429c2.538,2.156,3.894,4.167,1.449,4.22-2.271.048-5,2.98-5.657,3.723a.83.83,0,0,0,.08.169s3.2-3.858,5.8-3.892S61.082,708.541,58.217,706.25Z",
    transform: "translate(-101.284 -344.642)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4700",
    "data-name": "Path 4700",
    d: "M64.034,709.539c0,.482-.073.873-.167.873s-.167-.391-.167-.873.094-.256.187-.256S64.034,709.056,64.034,709.539Z",
    transform: "translate(-104.403 -346.184)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4701",
    "data-name": "Path 4701",
    d: "M65.021,710.715a2.955,2.955,0,0,1-1.142.309c-.04-.058.394-.289.982-.521s.354-.063.394,0S65.6,710.484,65.021,710.715Z",
    transform: "translate(-104.462 -346.782)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4702",
    "data-name": "Path 4702",
    d: "M56,721.892s-4.054-.092-5.276-.719-6.238-1.379-6.545-.371-6.091,5.015-1.516,5.04,10.639-.516,11.861-1.051S56,721.892,56,721.892Z",
    transform: "translate(-96.835 -351.921)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4703",
    "data-name": "Path 4703",
    d: "M42.589,727.183c4.581.029,10.639-.511,11.861-1.051.928-.405,1.3-1.871,1.423-2.551h.134s-.254,2.363-1.476,2.894-7.28,1.08-11.861,1.051c-1.336,0-1.777-.347-1.75-.849C41.1,726.99,41.641,727.159,42.589,727.183Z",
    transform: "translate(-96.836 -353.614)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_225",
    "data-name": "Ellipse 225",
    cx: 10.431,
    cy: 10.431,
    r: 10.431,
    transform: "translate(-25.566 50.677)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_226",
    "data-name": "Ellipse 226",
    cx: 10.431,
    cy: 10.431,
    r: 10.431,
    transform: "translate(476.027 134.035)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_227",
    "data-name": "Ellipse 227",
    cx: 10.431,
    cy: 10.431,
    r: 10.431,
    transform: "translate(288.515 17.551)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 17.482,
    cy: 17.482,
    r: 17.482,
    transform: "translate(-11.754 101.174)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4704",
    "data-name": "Path 4704",
    d: "M463.678,618.529l-1.234-1.234a1.32,1.32,0,0,1,0-1.928l10.824-10.833a1.32,1.32,0,0,1,1.928,0l10.824,10.824a1.34,1.34,0,0,1,0,1.928l-1.234,1.234a1.34,1.34,0,0,1-1.928,0l-6.4-6.747v16.009a1.33,1.33,0,0,1-1.33,1.34h-1.783a1.34,1.34,0,0,1-1.34-1.34v-15.99l-6.4,6.747a1.34,1.34,0,0,1-1.928-.01Z",
    transform: "translate(-291.831 -326.861)",
    fill: "#4c99e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4705",
    "data-name": "Path 4705",
    d: "M473.737,594.232A21.965,21.965,0,1,1,451.771,616.2a21.965,21.965,0,0,1,21.965-21.966m0-2.891A24.857,24.857,0,1,0,498.593,616.2a24.857,24.857,0,0,0-24.857-24.857Z",
    transform: "translate(-291.355 -326.399)",
    fill: "#4c99e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.f2742c20c64b0055f6ed695ce1d19426.svg";
export { ForwardRef as ReactComponent };